export default {
	defaultPadding: '15px',
	defaultPaddingNumber: 15,
	mediumPadding: '10px',
	smallMargin: '5px',
	textMargin: '3px',
	smallText: '12px',
	sloganTextSize: '18px',
	sloganDescriptionSize: '14px',
	middleSlogan: '16px',
	toolbarHeight: '60px',
	toolbarIconHeight: '30px',
	toolbarIconHeightSize: 35,
	listItemBorderRadius: '3px',
	progressTrackerLabelSize: 10,
	progressTrackerHeight: 50,
	progressTrackerStepWidth: 100,
	progressTrackerCircleSize: 25,
	xlTextSize: '25px',
	largeIcon: '75px',
	thickBorderButton: '3px',
	largeFontSizeButton: '25px',
	instantOptionsSize: '80px',
	defaultBorderRadius: '5px',

	metricSectionTitle: '12px',
	metricSectionValue: '20px',
	footerImgSize: '15px',
	footerButtonMinHeight: '120px',
	footerPoweredByMinHeight: '30px',
	navigationButtonTextSize: '13px',
	sloganWeight: 300,
	centeredSectionMaxWidth: '300px',
	actionButtonHeight: '60px',
	loaderBottomMargin: '50px',
	loaderFontSize: '25px',
	fullWidthButtonHeight: '40px'

};
